export class TaggedError extends Error {
    tag;
    constructor(name, message) {
        super(message);
        this.tag = name;
    }
    toString() {
        return this.tag;
    }
}
